import { baseQuery } from '../baseQuery';
import { ServiceAreaType, TechnicianServiceAreaData } from 'types';

type PutTechnicianServiceAreasPayload = {
  techId: number;
  area_type: ServiceAreaType;
  suburb_ids: number[];
};

export const putTechnicianServiceAreas = async (
  payload: PutTechnicianServiceAreasPayload,
): Promise<TechnicianServiceAreaData> => {
  const { techId, ...rest } = payload;
  const { data } = await baseQuery(`technicians/${techId}/service-areas`, {
    type: 'PUT',
    body: {
      ...rest,
    },
  });

  return data as TechnicianServiceAreaData;
};
